import Meetings from './Meetings.container';

export default Meetings;